import { View } from "react-native";
import { Link } from "expo-router";
import StyledText from "../components/common/ui/styled-text";
import { AlertCircle } from "lucide-react-native";

export default function NotFoundScreen() {
  return (
    <View className="flex-1 items-center justify-center bg-white px-4">
      <View className="items-center space-y-6">
        <View className="rounded-full bg-gray-100 p-6">
          <AlertCircle size={64} color="#6B7280" />
        </View>

        <View className="items-center space-y-2">
          <StyledText className="text-3xl font-bold text-gray-900">
            Page Not Found
          </StyledText>
          <StyledText className="text-center text-base text-gray-600">
            The page you're looking for doesn't exist or has been moved.
          </StyledText>
        </View>

        <Link
          href="/"
          className="rounded-lg bg-blue-600 px-6 py-3"
          accessibilityRole="button"
          accessibilityLabel="Return to home page"
        >
          <StyledText className="text-base font-semibold text-white">
            Return to Home
          </StyledText>
        </Link>
      </View>
    </View>
  );
}
